<div *ngIf="specials.length > 0">
  <div class="d-flex justify-content-end mb-3">
    <div class="searchbar">
      <input
        class="search_input"
        type="text"
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchTextChange()"
        placeholder="Zoeken.."
      />
      <div class="search_icon"><i class="fas fa-search"></i></div>
    </div>
  </div>
  <table class="table table-hover fixed-table-layout">
    <colgroup>
      <col class="selection-column" />
      <col class="sku-column" />
      <col class="description-column" />
      <col class="supplier-sku-column" />
      <col class="vendor-ic-column" />
      <col class="order-unit-column" />
      <col class="supplier-price-column" />
      <col class="sales-price-column" />
      <col class="margin-column" />
      <col class="delivery-days-column" />
      <col class="creation-by-column" />
      <col class="creation-date-column" />
    </colgroup>
    <thead>
      <tr>
        <th
          scope="col"
          class="p-0"
        >
          <button
            type="button"
            class="btn btn-primary"
            copySpecials
            [specials]="selectedSpecials"
            [disabled]="!selectedSpecials.length"
          >
            <i class="fa-solid fa-clipboard"></i>
          </button>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('sku', getNextAscending('sku'))"
        >
          <span>SKU</span>
          <div
            #sortIcons
            id="skuAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="skuDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('description', getNextAscending('description'))"
        >
          Omschrijving
          <div
            #sortIcons
            id="descriptionAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="descriptionDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('supplierSku', getNextAscending('supplierSku'))"
        >
          <span>Festo SKU</span>
          <div
            #sortIcons
            id="supplierSkuAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="supplierSkuDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('vendorIC', getNextAscending('vendorIC'))"
        >
          <span
            data-toggle="tooltip"
            title="Bestelcode"
            >IC1 / IC2
          </span>
          <div
            #sortIcons
            id="vendorICAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="vendorICDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('orderUnit', getNextAscending('orderUnit'))"
        >
          <span>MOQ</span>

          <div
            #sortIcons
            id="orderUnitAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="orderUnitDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('supplierPrice', getNextAscending('supplierPrice'))"
        >
          <span>Inkoop</span>
          <div
            #sortIcons
            id="supplierPriceAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="supplierPriceDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('salesPrice', getNextAscending('salesPrice'))"
        >
          <span>Verkoop</span>
          <div
            #sortIcons
            id="salesPriceAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="salesPriceDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('margin', getNextAscending('margin'))"
        >
          <span>Marge</span>
          <div
            #sortIcons
            id="marginAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="marginDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('deliveryDays', getNextAscending('deliveryDays'))"
        >
          <span>Lvt</span>
          <div
            #sortIcons
            id="deliveryDaysAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="deliveryDaysDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('creationBy', getNextAscending('creationBy'))"
        >
          <span>Door</span>
          <div
            #sortIcons
            id="creationByAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="creationByDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
        <th
          scope="col"
          class="sort"
          (click)="sortByField('creationDate', getNextAscending('creationDate'))"
        >
          <span>Op</span>
          <div
            #sortIcons
            id="creationDateAsc"
            class="fa-solid fa-sort-up sort-icon"
          ></div>
          <div
            #sortIcons
            id="creationDateDesc"
            class="fa-solid fa-sort-down sort-icon"
          ></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="
          let special of specials | searchFestoSpecials: searchText | paginate: { itemsPerPage: 10, currentPage: page }
        "
      >
        <td>
          <input
            type="checkbox"
            class="form-check-input scale-1-5"
            [checked]="isSelected(special)"
            (change)="toggleSelection(special, $event)"
          />
        </td>
        <th scope="row">{{ special.sku }}</th>
        <td>{{ special.description }}</td>
        <td>{{ special.supplierSKU }}</td>
        <td>{{ special.vendorIC1 }} <strong>/</strong> {{ special.vendorIC2 }}</td>
        <td class="text-end">{{ special.orderUnit }}</td>
        <td class="text-end text-nowrap">€{{ special.supplierPrice | smartRound: true }}</td>
        <td class="text-end text-nowrap">€{{ special.salesPrice | smartRound: true }}</td>
        <td class="text-end text-nowrap">{{ special.margin }}%</td>
        <td class="text-end">{{ special.deliveryDays < 0 ? 'n/a' : special.deliveryDays }}</td>
        <td>{{ special.creationBy }}</td>
        <td>
          {{ special.creationDate! | utcDate: 'yyyy-MM-dd' }}
        </td>
      </tr>
    </tbody>
  </table>
  <pagination-controls
    (pageChange)="page = $event"
    previousLabel="Vorige"
    nextLabel="Volgende"
    [autoHide]="true"
  ></pagination-controls>
</div>
